/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    CloneReport,
    CloneReportFromJSON,
    CloneReportFromJSONTyped,
    CloneReportToJSON,
} from './CloneReport';

/**
 *
 * @export
 * @interface ApiResultOfCloneReport
 */
export interface ApiResultOfCloneReport {
    /**
     *
     * @type {CloneReport}
     * @memberof ApiResultOfCloneReport
     */
    data?: CloneReport;
    /**
     *
     * @type {string}
     * @memberof ApiResultOfCloneReport
     */
    message?: string;
    /**
     *
     * @type {object}
     * @memberof ApiResultOfCloneReport
     */
    messageValues?: object;
    /**
     *
     * @type {string}
     * @memberof ApiResultOfCloneReport
     */
    requestId?: string;
    /**
     *
     * @type {string}
     * @memberof ApiResultOfCloneReport
     */
    result?: ApiResultOfCloneReportResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfCloneReportResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfCloneReportFromJSON(json: any): ApiResultOfCloneReport {
    return ApiResultOfCloneReportFromJSONTyped(json, false);
}

export function ApiResultOfCloneReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfCloneReport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'data': !exists(json, 'data') ? undefined : CloneReportFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfCloneReportToJSON(value?: ApiResultOfCloneReport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'data': value.data === undefined ? undefined : CloneReportToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}
